﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export const useStyles = createUseStyles((theme: ConsilioBaseTheme) => ({
    grid: {
        "@media (orientation : landscape)": {
            gridTemplateColumns: "250px 150px",
        },
    },
}));
